import { render, staticRenderFns } from "./adDetail.vue?vue&type=template&id=fc4bc3ac&scoped=true&"
import script from "./adDetail.vue?vue&type=script&lang=js&"
export * from "./adDetail.vue?vue&type=script&lang=js&"
import style0 from "./adDetail.vue?vue&type=style&index=0&id=fc4bc3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4bc3ac",
  null
  
)

export default component.exports